export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";